import { Component, EventEmitter, Input, Output, Pipe, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Subject, take, takeUntil, map } from 'rxjs';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { FieldDictionaryListService } from 'src/app/tabms/services/global/field-dictionary-list.service';
import { SqlSearchService } from 'src/app/tabms/services/sql-search/sql-search.service';
import { PopUpSearchComponent } from '../../../global/pop-up-search/pop-up-search.component';
import { TranslateService } from '@ngx-translate/core';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { TabConst } from 'src/app/tabms/tab-consts';
import { FieldDictionaryDto, listResponseModel, ResponseModel, SingleResponseModel } from 'src/app/tabms/models/base/base';

@Component({
  selector: 'app-input-with-sql-search',
  templateUrl: './input-with-sql-search.component.html',
  styleUrl: './input-with-sql-search.component.scss'
})
export class InputWithSqlSearchComponent {
  @Input() control: FormControl = new FormControl()
  @Input() type: string = ''
  @Input() serviceInstance
  @Input() searchProperty
  @Input() fieldName
  @Input() getByKey
  @Input() customErrorStyle
  @Input() selectedItem
  @Input() extraParams: any = null
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE // New input for size control
  @Input() fetchFlag
  @Input() IsFooterUpdated: boolean = false;
  @Output() selected = new EventEmitter<string>()
  placeholder: string
  dropDownData: any[] = []
  systemMenuId
  fieldId = ''
  selectedCode: string = '';
  // form: FormGroup
  displayName: string = ''
  selectedId: string | null = null
  fieldsHaveSqlQueries: any = {}
  currentLang: string;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    private baseService: BaseService,
    private fieldDictionaryListService: FieldDictionaryListService,
    private activateRoute: ActivatedRoute,
    private sqlSearchService: SqlSearchService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private themeLayoutService: ThemeLayoutService
  ) {
    //get systemMenuId
    this.activateRoute.params.subscribe(params => {
      this.systemMenuId = params['id'];
    });

    //#region intialization
    this.currentLang = this.baseService.getCurrentLanguage();
    //#endregion

    //#region on language change
    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
        this.setPlaceholder();
      }
    });
    //#endregion
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes', changes)
    console.log("isFooterUpdatedSubscription", this.IsFooterUpdated);

    if (changes['selectedItem'] && !this.IsFooterUpdated) {
      //debugger
      const curr = changes['selectedItem'].currentValue;
      if (curr) {
        const searchValue = { [this.getByKey]: curr }
        this.getByCode(searchValue);
      } else {
        this.displayName = '';
        this.selectedId = null;
        this.control.setValue(null);
        this.selected.emit(null);
      }
    }

    // Re-run query when extraParams change (cascade filters)
    if (changes['extraParams'] && !changes['extraParams'].firstChange) {
      const currVal = this.control?.value;
      if (currVal !== null && currVal !== undefined && currVal !== '') {
        const searchValue = { [this.getByKey]: currVal };
        this.getByCode(searchValue);
      }
    }
  }

  ngOnInit(): void {
    this.fieldDictionaryListService.getList().subscribe({
      next: (res) => {
        // console.log(res);
        const pageData = res.find((x) => x.pageid == this.systemMenuId)
        if (!pageData) return;
        const displayData = pageData.list;

        displayData.forEach((element: FieldDictionaryDto) => {
          if (element.searchsqlquery && element.fieldname) {
            this.fieldsHaveSqlQueries[element.fieldname] = element.id;
          }
        });
        console.log('SQL Queries:', this.fieldsHaveSqlQueries, this.fieldName);


        this.fieldId = this.fieldsHaveSqlQueries[this.fieldName];

        if (!this.fieldId) {
          this.fieldId = '';
          this.selectedId = this.control.value;
          this.setDropDownData();
          console.log('dropdown', this.dropDownData, this.selectedId);
        }

      }
    });

    this.setPlaceholder();

    // react to external control clears
    if (this.control) {
      this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((v) => {
        if (v === null || v === undefined || v === '') {
          this.displayName = '';
          this.selectedId = null;
          this.selected.emit(null);
        }
      })
    }

  }

  // ngAfterViewInit(): void {
  //   console.log('control', this.control.value)
  // }

  popUpShow() {
    let dialogRef = this.dialog.open(PopUpSearchComponent, {
      height: '80vh',
      width: '90vw',
      maxWidth: '1200px',
      maxHeight: '800px',
      direction: this.baseService.getDirection(),
      data: { service: this.sqlSearchService, fieldDictionaryId: this.fieldId }
    })

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(selectedData => {
      console.log('The dialog was closed', selectedData);
      if (selectedData !== undefined) {
        // console.log(selectedId);
        const value = Object.values(selectedData)
        //  console.log(value);
        // this.control.setValue(value)
        this.getByCode(selectedData)
      }
      else {
        this.control.setValue(null)
      }
    });
  }

  onInputSearch(event) {
    console.log('inputSearch', event.target.value);
    if (!event.target.value) {
      this.control.markAsTouched();
      this.control.setValue(null);
      this.displayName = '';
      this.selected.emit(null);
      return;
    }
    const searchValue = { [this.getByKey]: event.target.value }
    this.getByCode(searchValue);
  }

  getByCode(pageParams) {
    // let params = { SkipCount: 0, MaxResultCount: 1 }
    // params = { ...params, ...pageParams }
    const mergedParams = { ...(this.extraParams || {}), ...(pageParams || {}) };
    this.serviceInstance.GetalldatabyfilterWithCount(0, 1, mergedParams).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        //debugger
        console.log(res);
        if (res && res?.result?.totalcount > 0) {
          const lowerEntity = Object.fromEntries(
            Object.entries(res.result.items[0]._entitydto).map(([k, v]) => [k.toLowerCase(), v])
          );
          const value = lowerEntity[this.getByKey.toLowerCase()];
          this.control.setValue(value)
          console.log(this.control, this.control.value)
          this.displayName = res.result.items[0]._entitydto[this.searchProperty];
          const rawItem = res.result?.items?.[0] ?? null;
          const entityDto = rawItem?._entitydto ?? null;
          const zeroGuid = '00000000-0000-0000-0000-000000000000';
          const entityId = entityDto && entityDto.id && entityDto.id !== zeroGuid ? entityDto.id : undefined;
          const topLevelId = rawItem && rawItem.id && rawItem.id !== zeroGuid ? rawItem.id : undefined;
          this.selectedId = entityId ?? topLevelId ?? value ?? null;
          const data = res.result ? res.result.items[0]._entitydto : null
          this.selected.emit(data);
        }
        else {
          this.control.markAsTouched();
          this.control.setErrors({ notFound: true });
          console.log(this.control, this.control.value)
          this.displayName = '';
          this.selected.emit(null);

        }
      },
      error: (err) => {
        this.control.markAsTouched();
        this.control.setErrors({ notFound: true });
        this.displayName = '';
        console.log(this.control, this.control.value)
        this.selected.emit(null);
      }

    })
  }

  setDropDownData() {
    console.log('setDropDownData');
    this.serviceInstance.getAllbyFilter().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        console.log(res);
        const data = res.result.items.map(x => x._entitydto) ?? res.items ?? res
        this.dropDownData = data;
        console.log('dropdown', this.dropDownData, this.selectedId);
      }
    })
  }

  onSelected(event) {
    console.log(event);
    this.selected.emit(event);
  }

  setPlaceholder(): void {
    this.fieldDictionaryListService.getList().subscribe({
      next: (res) => {
        // console.log(res);
        const pageData = res.find((x) => x.pageid == this.systemMenuId)
        if (!pageData) return;
        const fieldList = pageData.list.find((x) => x.fieldname.toLowerCase() === this.fieldName?.toLowerCase());

        const fieldNameTranslation = this.currentLang === 'ar' ?
          fieldList?.langvalue.find(x => x.culturename == 'ar-EG')?.value
          : fieldList?.langvalue.find(x => x.culturename == this.currentLang)?.value;

        if (this.fieldId) {
          if (fieldNameTranslation) this.placeholder = this.translate.instant('enter') + ' ' + fieldNameTranslation;
          else this.placeholder = this.translate.instant('enter') + ' ' + this.translate.instant(this.fieldName);
          // else this.placeholder = this.translate.instant('enter')
        }
        else {
          if (fieldNameTranslation) this.placeholder = this.translate.instant('select') + ' ' + fieldNameTranslation;
          else if (this.fieldName && !fieldNameTranslation) this.placeholder = this.translate.instant('select') + ' ' + this.translate.instant(this.fieldName);
          else this.placeholder = this.translate.instant('select')
        }

      }
    })
  }

  //region destory subscribtion
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  //end region

}
